const APP_CONFIG = {
    FREE_PLAY_TIME: 24
};

export {APP_CONFIG};